import { render, staticRenderFns } from "./Articles.vue?vue&type=template&id=67395ba6&scoped=true"
import script from "./Articles.vue?vue&type=script&lang=js"
export * from "./Articles.vue?vue&type=script&lang=js"
import style0 from "./Articles.vue?vue&type=style&index=0&id=67395ba6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67395ba6",
  null
  
)

export default component.exports